import { createLogic } from "redux-logic";
import Debug from "../../../../common-deprecated/Debug";
import type { ExternalConfigType } from "../../../shared-logic/types/ExternalPriceType";
import type { EquipmentCategoryType } from "../utils/types";
import {
    type StartFetchType,
    EQUIPMENT_V2_FINANCE_START_FETCH,
    errorFinanceFetch,
    finishFinanceFetch,
} from "../redux/actions/EquipmentFinanceActions";
import type { EquipmentV2LogicType } from "../redux/store";
import { fetchMonthlyRate } from "../utils/utils";

const financeFetchLogic = (createLogic as EquipmentV2LogicType<StartFetchType>)({
    type: EQUIPMENT_V2_FINANCE_START_FETCH,
    async process({ getState }, dispatch, done) {
        const { commonSettings, equipmentV2Settings, equipment, finance } = getState();
        const items = equipment.optional.length ? equipment.optional : equipment.standard;

        const config: ExternalConfigType = {
            Country: commonSettings.country,
            Brand: commonSettings.brand,
            Language: commonSettings.language,
            ModelID: equipment.selectedCar.modelId,
            CarID: equipment.selectedCar.carId,
            ExteriorColourID: equipment.selectedCar.colourId || "",
            UpholsteryID: equipment.selectedCar.upholsteryId || "",
        };

        const itemIds = items.reduce((prevItems: { Id: string }[], itemCategory: EquipmentCategoryType) => {
            return [
                ...prevItems,
                ...itemCategory.items.map((item) => ({
                    Id: item.id,
                })),
            ];
        }, []);

        try {
            const result = await fetchMonthlyRate(
                equipmentV2Settings,
                config,
                // None of the items are really selected so leaving this as an empty array
                [],
                itemIds,
            );

            const { unselectedItemPrices, selectedItemPrices } = result;

            const newRates = { ...finance.itemRates };

            unselectedItemPrices.forEach((rate) => {
                newRates[rate.id] = rate.value;
            });
            selectedItemPrices.forEach((rate) => {
                newRates[rate.id] = rate.value;
            });

            dispatch(finishFinanceFetch(result, newRates));
        } catch (error) {
            dispatch(errorFinanceFetch());
            Debug.error("Failed to fetch finance Rate", error);
        }

        done();
    },
});

export default [financeFetchLogic];
